import { memo, useEffect } from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

function OrthopaedicClinic() {
  useEffect(() => {
    document.title = "Orthopaedic Clinic | Viksha Health Care";
    const newMetaDescription =
      "Orthopaedic clinic at Viksha Health Care for bone, joint, muscle and ligament concerns. Learn what to expect during evaluation and treatment planning.";
    const metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) {
      metaTag.setAttribute("content", newMetaDescription);
    }
  }, []);

  return (
    <>
      <h2 style={{ fontSize: "0px" }}>Orthopaedic Clinic</h2>
      <div className="serinfobox">
        <div className="serinfoimg">
          <LazyLoadImage src="/photo/Orthopaedic-Clinic.avif" />
        </div>
        <div className="textareaofser">
          <h1>Orthopaedic Clinic</h1>

          <p>
            Our orthopaedic clinic cares for problems affecting bones, joints,
            muscles, tendons, and ligaments. We help identify the cause of pain,
            stiffness, swelling, or limited movement and guide you toward the
            right treatment.
          </p>

          <p>
            Whether your problem is due to injury, overuse, aging, or a chronic
            condition, early evaluation can reduce pain, improve mobility, and
            prevent long-term complications.
          </p>

          <h5>What to Expect During Your Visit</h5>

          <h6>Clinical Evaluation</h6>
          <p>
            A detailed discussion of your symptoms along with a focused physical
            examination helps determine the source of your problem.
          </p>

          <h6>Investigations (If Needed)</h6>
          <p>
            X-rays or other imaging tests may be advised to confirm the
            diagnosis and plan treatment accurately.
          </p>

          <h6>Treatment Planning</h6>
          <p>
            Treatment may include medicines, physiotherapy, injections,
            splints/casts, or surgery when necessary. Care plans are
            personalized based on your condition, age, and activity level.
          </p>

          <h5>Common Conditions We Manage</h5>
          <ul>
            <li>Joint pain in the knee, hip, shoulder, and ankle</li>
            <li>Back and neck pain</li>
            <li>Sports injuries and ligament tears</li>
            <li>Fractures, sprains, and trauma-related injuries</li>
            <li>Arthritis and age-related joint problems</li>
            <li>Tendon and muscle injuries</li>
          </ul>

          <h5>Non-Surgical Care</h5>
          <p>
            Many orthopaedic problems improve with non-surgical treatment such
            as medication, physiotherapy, joint support braces, and activity
            modification. Early conservative care often helps avoid surgery.
          </p>

          <h5>Minor Procedures in Clinic</h5>
          <ul>
            <li>Joint injections for selected painful conditions</li>
            <li>Application of casts or splints for fractures and injuries</li>
            <li>Follow-up care for musculoskeletal injuries</li>
          </ul>

          <h5>When Surgery Is Considered</h5>
          <p>
            Surgery may be recommended if pain persists despite conservative
            treatment or if there is significant structural damage to the joint
            or bone. The goal is to relieve pain and restore movement.
          </p>

          <h5>Rehabilitation Support</h5>
          <p>
            Recovery includes guided exercises and gradual return to daily
            activities to restore strength, flexibility, and mobility after
            injury or treatment.
          </p>

          <h5>When to Seek Orthopaedic Care</h5>
          <ul>
            <li>Pain lasting more than a few days</li>
            <li>Swelling or stiffness in a joint</li>
            <li>Difficulty walking or moving normally</li>
            <li>Pain after a fall or sports injury</li>
            <li>Reduced range of motion in any joint</li>
          </ul>

          <p>
            Early orthopaedic evaluation can relieve pain, prevent
            complications, and help you return to an active and comfortable
            life.
          </p>
        </div>
      </div>
    </>
  );
}

export default memo(OrthopaedicClinic);
